var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%","height":"100%","background-color":"#2c3e50"}},[_c('Nav'),_c('div',{staticStyle:{"padding-top":"20%","color":"#bfcbd9","font-size":"50px","text-align":"center"}},[_vm._v(" 没有找到 ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }